<template>
  <div>
    <el-cascader popper-class="city-el-cascader" :placeholder="placeholderWord" style="width: 400px" clearable
      v-model="editItem.values" :props="cascaderProps" @change="cascaderChange" size="medium"></el-cascader>
  </div>
</template>
<script>
import _ from 'lodash'
import './index.scss'
import VueI18n from 'vue-i18n'
import { getTopicDivision, getTopicDivisionOuterWifi } from '@/services/survey'
import { getQueryString } from '@/utils/utils'
export default {
  props: {
    item: {
      type: Object,
      default: () => { }
    },
    i18n: {
      type: VueI18n
    },
    isViewAnswer: {
      type: Boolean,
      default: false
    },
    outerNet: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editItem: _.cloneDeep(this.item), //编辑数据源
      errorText: '',
      cascaderProps: {
        lazy: true,
        value: 'key',
        label: 'value',
        children: 'children',
        lazyLoad: async (node, resolve) => {
          console.log('getLanguageCode', this.getLanguageCode())
          const { level } = node
          let name = node.value
          if (level === 0) {
            name = this.item?.topicSetting?.countryTopicOption
          }
          // 获取语言
          // 根节点
          let { data } = await (this.outerNet
            ? getTopicDivisionOuterWifi
            : getTopicDivision)({
              name,
              level,
              languageCode: this.getLanguageCode()
            })
          data = data.map((item) => {
            return Object.assign({}, item, {
              leaf: !item.hasChildren
            })
          })
          resolve(data || [])
          this.$nextTick(() => {
            // 获取目标元素
            const element = document.querySelector(
              '.city-el-cascader .el-cascader-panel'
            )
            // 计算最大滚动距离
            const maxScrollLeft = element.scrollWidth - element.clientWidth

            // 滚动到最右边
            element.scrollTo({
              left: maxScrollLeft, // 目标位置
              behavior: 'smooth' // 平滑滚动效果（可选）
            })
          })
        }
      }
    }
  },
  computed: {
    placeholderWord() {
      return this.i18n?.t('common.selectPlaceholder')
    }
  },
  methods: {
    getLanguageCode() {
      const china_damain = [
        'cem-survey-test.wanyol.com',
        'cem.myoas.com',
        'cem-survey.myoas.com',
        'cem-test.wanyol.com',
        'localhost'
      ]
      // 首先从url上取
      let languageCode = getQueryString('languageCode')
      if (languageCode) {
        // 判断是否是中文，否则就是英文
        if (languageCode !== 'ZH_CN') {
          languageCode = 'EN'
        }
      } else {
        // 从问卷详情中获取
        languageCode = this.item?.languageCode
        if (languageCode) {
          if (languageCode !== 'ZH_CN') {
            languageCode = 'EN'
          }
        } else {
          languageCode = china_damain.includes(window.location.hostname) ? 'ZH_CN' : 'EN'
        }
      }
      return languageCode
    },
    cascaderChange(val) {
      // 滚动条定位
      this.$emit('answer', _.cloneDeep(this.editItem))
    }
  },
  watch: {
    item: {
      handler: (val, oldVal) => {
        this?.$nextTick(() => {
          this.editItem = _.cloneDeep(val)
        })
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
